import { render, staticRenderFns } from "./individual_tax.vue?vue&type=template&id=521f592e&scoped=true"
import script from "./individual_tax.vue?vue&type=script&lang=js"
export * from "./individual_tax.vue?vue&type=script&lang=js"
import style0 from "@/styles/index.styl?vue&type=style&index=0&id=521f592e&prod&lang=stylus&scoped=true&external"
import style1 from "./individual_tax.vue?vue&type=style&index=1&id=521f592e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521f592e",
  null
  
)

export default component.exports